import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import pageCanonicals, { siteUrl } from "../data/pageCanonicals";

const PageCanonical = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const exactCanonical = pageCanonicals[pathname];
    const matchedEntry =
      exactCanonical !== undefined
        ? { pattern: pathname, match: { params: {} } }
        : Object.keys(pageCanonicals)
            .map((pattern) => ({
              pattern,
              match: matchPath({ path: pattern, end: true }, pathname),
            }))
            .find(({ match }) => match);

    const configuredCanonical = matchedEntry
      ? pageCanonicals[matchedEntry.pattern]
      : undefined;
    const normalizedPath =
      pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const canonicalUrl = configuredCanonical
      ? typeof configuredCanonical === "function"
        ? configuredCanonical(matchedEntry.match.params)
        : configuredCanonical
      : `${siteUrl}${normalizedPath}`;

    const canonicalLink = document.createElement("link");
    canonicalLink.rel = "canonical";
    canonicalLink.href = canonicalUrl;
    canonicalLink.dataset.pageCanonical = "true";
    canonicalLink.dataset.canonicalRoute = matchedEntry?.pattern || "automatic";
    document.head.appendChild(canonicalLink);

    return () => {
      canonicalLink.remove();
    };
  }, [pathname]);

  return null;
};

export default PageCanonical;
